import React, { Fragment } from "react";
import * as style from "./styles.module.scss";
import { Checkbox, TextAreaGroup } from "../../common";
import RadioButton from "../../common/RadioButton";

const SurveyCreator = ({
  handleSubmit,
  activeQuestions,
  step,
  handleNext,
  values,
  setValues,
}) => {
  const questionsNumber = activeQuestions.length;

  const ratingStar = (el, i) => (
    <Fragment>
      <input
        onClick={() => setValues({ ...values, [el.id]: 10 - i })}
        type="radio"
        name="rating"
        id={`rating-${i}`}
      />
      <label htmlFor={`rating-${i}`}></label>
    </Fragment>
  );

  const isLastQuestions = (i) => (
    <Fragment>
      <p>Question {`${i + 1}/${questionsNumber}`}</p>
      <div style={{ display: "flex" }}>
        {questionsNumber === i + 1 ? (
          <button className="btn btn-primary" onClick={handleSubmit}>
            Submit
          </button>
        ) : (
          <button className="btn btn-primary" onClick={handleNext}>
            Next
          </button>
        )}
      </div>
    </Fragment>
  );

  const handleMultipleOptions = (question, newValue) => {
    const prev = values[question.id] || [];

    if (prev.find((p) => p === newValue)) {
      setValues({
        ...values,
        [question.id]: prev.filter((el) => el !== newValue),
      });
    } else {
      setValues({ ...values, [question.id]: [...prev, newValue] });
    }
  };

  const displayCheckboxOptions = (question) => {
    return [...Array(6)].map((_, optionNumber) => {
      const option = question[`option${optionNumber + 1}`];
      if (option) {
        return (
          <Checkbox
            key={optionNumber}
            onClick={() => handleMultipleOptions(question, option)}
            style={{ color: "white" }}
            label={option}
          />
        );
      }
      return <></>;
    });
  };

  const displayRadioOptions = (question) => {
    return [...Array(6)].map((_, optionNumber) => {
      const option = question[`option${optionNumber + 1}`];
      if (option) {
        return (
          <Fragment key={optionNumber}>
            <RadioButton
              label={option}
              isChecked={values[question.id] === option}
              onClick={() => setValues({ ...values, [question.id]: option })}
            />
          </Fragment>
        );
      }
      return <></>;
    });
  };

  const displayQuestions = () =>
    activeQuestions.map((el, i) => {
      if (el.type === "text_field") {
        return (
          <Fragment key={i}>
            {step === i && (
              <div className={style.questionsContainer}>
                <div className={style.question}>
                  <div>{el.contents}</div>
                  <TextAreaGroup
                    onChange={(e) =>
                      setValues({ ...values, [el.id]: e.target.value })
                    }
                    value={values[el.id]}
                    resizable={false}
                  />
                </div>
                <div className={style.steps}>{isLastQuestions(i)}</div>
              </div>
            )}
          </Fragment>
        );
      }
      if (el.type === "scale") {
        return (
          <Fragment key={i}>
            {step === i && (
              <div className={style.questionsContainer}>
                <div className={style.question}>
                  <div className="flex">{el.contents}</div>
                  <div className={style.rating}>
                    {[...Array(10)].map((_, index) => ratingStar(el, index))}
                  </div>
                </div>
                <div className={style.steps}>{isLastQuestions(i)}</div>
              </div>
            )}
          </Fragment>
        );
      }
      return (
        <Fragment key={i}>
          {step === i && (
            <div className={style.questionsContainer}>
              <div className={style.question}>
                <div>{el.contents}</div>
                <div className={style.checkbox_options_wrapper}>
                  {el.type === "radio"
                    ? displayRadioOptions(el)
                    : displayCheckboxOptions(el)}
                </div>
              </div>
              <div className={style.steps}>{isLastQuestions(i)}</div>
            </div>
          )}
        </Fragment>
      );
    });

  return (
    <Fragment>
      {displayQuestions()}
      {step === questionsNumber && (
        <div className={style.questionsContainer}>
          Your Feedback has been submitted.
          <p>Thank you for your time!</p>
        </div>
      )}
    </Fragment>
  );
};

export default SurveyCreator;
